import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import capitalize from 'lodash/capitalize'
import { Button } from 'transfix-ui/components/Button'
import { Typography, makeStyles } from 'transfix-ui/core'
import { autoConfirmStop } from 'utils/actions/shipmentStop'
import { formatDate } from 'apps/schedule/utils/schedule'
import { scheduleActionsSelector } from 'apps/schedule/utils/selectors/scheduleActions'
import { IStop } from 'apps/schedule/utils/types/stops'

export interface IFCFSButtonProps {
  stop: IStop
}

const useFCFSButtonStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  button: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      maxWidth: 460,
    },
  },
}))

export const FCFSButton = React.memo(({ stop }: IFCFSButtonProps) => {
  const styles = useFCFSButtonStyles()
  const state = useSelector(scheduleActionsSelector)
  const { submitting } = state
  const dispatch = useDispatch()
  const { autoConfirmToken, endAtTime, startAtDate, startAtTime, stopId, stopType } = stop
  const confirmStop = () => {
    dispatch(autoConfirmStop(stopId, autoConfirmToken, startAtTime, endAtTime))
  }
  const key = `${stop.stopId}-fcfs`
  return (
    <div className={styles.root}>
      <Typography variant='h3'>
        {capitalize(stopType)} on {formatDate(startAtDate || '')} ({startAtTime || '00:00'} to{' '}
        {endAtTime || '23:59'})
      </Typography>
      <div>
        <Typography variant='subtitle2'>Click to confirm</Typography>
        <Typography variant='subtitle2' color='textSecondary'>
          Please confirm the following date and hours for first come, first served.
        </Typography>
      </div>
      <Button
        className={styles.button}
        fullWidth
        color='primary'
        onClick={confirmStop}
        key={key}
        data-test={key}
        disabled={submitting}>
        Confirm {capitalize(stopType)}
      </Button>
    </div>
  )
})
